import React from 'react';
import FlatButton from 'components/pure/utils/FlatButton';
import ChevronLeftIcon from 'material-ui/svg-icons/navigation/chevron-left';
import './LiveCoachingOverrideNav.styl';
import connectToStores from 'alt-utils/lib/connectToStores';
import LiveCoachingStore from 'stores/scorecards/LiveCoachingStore';
import UserStore from 'stores/UserStore';
import UserAvatar from 'components/pure/utils/UserAvatar';
import UserActions from 'actions/UserActions';
import {List} from 'immutable';
import confirm from 'utils/confirm';
import noop from 'lodash/noop';
import Button from '@material-ui/core/Button';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import ScorecardQuestionnaireStore from 'stores/scorecards/ScorecardQuestionnaireStore';

export const overrideName = 'LiveCoachingOverride';

@connectToStores
export default class LiveCoachingOverrideNav extends React.Component {
  constructor(props) {
    super(props);

    this.cancel = this.cancel.bind(this);
  }

  componentDidMount() {
    const {coachId, recipientId} = LiveCoachingStore.getState();

    if (coachId && recipientId) {
      UserActions.fetchAll.defer({ids: List([coachId, recipientId])});
    }
  }

  static getStores() {
    return [UserStore, LiveCoachingStore, ScorecardQuestionnaireStore];
  }

  static getPropsFromStores() {
    const {users} = UserStore.getState();
    const {coachId, recipientId} = LiveCoachingStore.getState();
    return {
      coach: users.get(coachId),
      recipient: users.get(recipientId),
      // Changes to answers can change form validity.
      // Use these to force rerender on answer changes so we can pick up changes to the submit
      // button (if it's visible).
      answers: ScorecardQuestionnaireStore.getState().get('answers'), // it's a map.
    };
  }

  cancel() {
    confirm('Are you sure you want to cancel this coaching session?').then(() => {
      this.props.goBack();
    }, noop);
  }

  render() {
    const {
      coach,
      recipient,
      name, // name of the selected scorecard, if any.
      hasMultipleScorecards,
      submit,
      cancel,
      disableSubmit,
    } = this.props;

    // name is also set when showing the results. make sure we only render these buttons
    // when the questionnaire is active.
    const showButtons = name && submit && cancel && disableSubmit;

    return (
      <div className="live-coaching-header">
        <div className="wrapper">
          <div className="back">
            {name && hasMultipleScorecards ? (
              // has selected one of several scorecards -- go back to chooser.
              <FlatButton
                className="back-button"
                onClick={this.props.goToChooser}
                icon={<ChevronLeftIcon className="icon chevron-left" />}
                label="Score more cards"
              />
            ) : (
              // no scorecard selected, or only one available -- end session.
              <FlatButton
                className="back-button"
                onClick={this.cancel}
                icon={<ChevronLeftIcon className="icon chevron-left" />}
                label="Cancel Session"
              />
            )}
          </div>
          {coach && recipient && (
            <div className="title">
              <div className="avatar-wrapper">
                <UserAvatar user={coach} />
                <UserAvatar user={recipient} />
              </div>
              <header>
                Live Coaching Session - {coach.firstName} & {recipient.firstName}
              </header>
            </div>
          )}
          <div className="actions">
            {showButtons && (
              <div>
                <Button variant="outlined" className="ev-button" onClick={() => cancel()}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  className="save-button ev-button"
                  icon={<CheckIcon className="icon check" />}
                  onClick={() => submit()}
                  disabled={disableSubmit()}>
                  Save
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
